
export default {
    name: 'LeeStarEvaluate',
    inheritAttrs: false,
    data() {
        return {
            on: 0
        };
    },
    mounted() {

    },
    computed:{
        typeStyle(){
            return{
                face:this.type==='face',
                star:this.type==='star',
                love:this.type==='love'||'',
            }

        }
    },
    props: {
        value: {
            type: Number,
            default: 0 //默认1
        },
        num: {
            type: Number,
            default: 5 //默认1
        },
        type: {
            type: String,
            default: 'love'
        },
        initColor: {
            type: String,
            default: '#ccc'
        },
        hoverColor: {
            type: String,
            default: '#46bd87'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.on=value
            }
        },
    },
    methods: {
        mouseover(i) {
            this.on = i + 1
        },
        mouseout() {
            this.on = this.value
        },
        setcur(i) {
            this.$emit('change', i + 1)
            this.$emit('input', i + 1)
        }
    }
};
